import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  webMenuData: [],
  viewWebMenuData: [],
};

const WebMenuSlice = createSlice({
  name: "WebMenuSlice",
  initialState,
  reducers: {
    setWebMenuData: (state, action) => {
      state.webMenuData = action.payload;
    },
    setViewWebMenuData: (state, action) => {
      state.viewWebMenuData = action.payload;
    },
  },
});
export const { setWebMenuData, setViewWebMenuData } = WebMenuSlice.actions;

export default WebMenuSlice.reducer;